module.exports = __webpack_public_path__ + "static/media/360@2x.54787eb6.png";